import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class CampaignEmployeeService {
	constructor(private dataService: OldDataService, private http: HttpClient, private utils: UtilsService) {}

	getListUsers(idCampaign) {
		const url = `${environment.api}user/get_users_by_campaign`;
		const formData: any = this.utils.jsonToFormData({ campaignid: idCampaign });
		return this.http.post(url, formData);
	}

	assignCampaignToUser(idUser, idCampaign) {
		const url = `${environment.api}user/assign_campaign_to_user`;
		const formData: any = this.utils.jsonToFormData({
			user: idUser,
			campaign: idCampaign,
		});
		return this.http.post(url, formData);
	}

	removeUser(idUser, idCampaign) {
		const url = `${environment.api}user/remove_campaign_from_user`;
		const formData: any = this.utils.jsonToFormData({
			user: idUser,
			campaign: idCampaign,
		});
		return this.http.post(url, formData);
	}

}
